export const formatDocumentTitle = (pageTitle: string | undefined, appTitle: string, badgeCount = 0): string => {
  const base = pageTitle ? `${pageTitle} | ${appTitle}` : appTitle;
  return badgeCount > 0 ? `(${badgeCount}) ${base}` : base;
};

export const formatPageTitle = (title: string | null | undefined, parentTitle: string): string =>
  title && title !== parentTitle ? `${title} — ${parentTitle}` : parentTitle;

export const pageTitleFromDocumentTitle = (documentTitle: string): string => {
  const withoutBadgeCount = documentTitle.replace(/^\(\d+\)\s+/, "");
  const appTitleSeparator = withoutBadgeCount.lastIndexOf(" | ");
  return appTitleSeparator > 0 ? withoutBadgeCount.slice(0, appTitleSeparator) : withoutBadgeCount;
};
